import { useCallback, useEffect, useState } from 'react';
import { message } from 'antd';
import { FIND, FIND_KEY, process } from '../Service/Api';

export const useFetchFormsSAT = (queries = '', skip = 0, limit = 10) => {
  const [data, setData] = useState({ data: [] });
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({ queries, limit, skip });

  const getFormsPay = useCallback(async () => {
    setLoading(true);
    const response = await process(FIND, 'payment-forms', {}, params);
    if (response?.ok) {
      setData(response.data);
    } else {
      message.error('Error al consultar Formas de Pago Sucursal');
    }
    setLoading(false);
  }, [process, params]);

  useEffect(() => {
    getFormsPay();
  }, [getFormsPay]);

  const onChangeParams = (q = '', s = 0, l = 10) =>
    setParams({ queries: q, limit: l, skip: s });

  const update = () => getFormsPay();

  return [data, loading, onChangeParams, update];
};

export const useFetchFormsSATWithApiKey = (
  queries = '',
  skip = 0,
  limit = 10
) => {
  const [data, setData] = useState({ data: [] });
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({ queries, limit, skip });

  const getFormsPay = useCallback(async () => {
    setLoading(true);
    const response = await process(FIND_KEY, 'payment-forms', {}, params);
    if (response?.ok) {
      setData(response.data);
    } else {
      message.error('Error al consultar Formas de Pago Sucursal');
    }
    setLoading(false);
  }, [process, params]);

  useEffect(() => {
    getFormsPay();
  }, [getFormsPay]);

  const onChangeParams = (q = '', s = 0, l = 10) =>
    setParams({ queries: q, limit: l, skip: s });

  const update = () => getFormsPay();

  return [data, loading, onChangeParams, update];
};
